// @ts-ignore no types
import Cookies from 'js-cookie';
import { BUYER_LOGO_PATH } from './paths';
import { getPortalAccountId, getPortalInstanceId } from '../utils/portalMetaUtils';
export function createBuyerLogoUploadClient(dealPlanId) {
  return {
    post: async (_url, options) => {
      var _Cookies$get;
      const accountId = getPortalAccountId();
      const portalInstanceId = getPortalInstanceId();
      const csrfToken = (_Cookies$get = Cookies.get('__Host-hs-membership-csrf')) !== null && _Cookies$get !== void 0 ? _Cookies$get : Cookies.get('hs-membership-csrf');
      const params = new URLSearchParams();
      params.set('dealPlanId', String(dealPlanId));
      if (accountId !== undefined) params.set('accountId', String(accountId));
      if (portalInstanceId !== undefined) params.set('portalInstanceId', String(portalInstanceId));
      const response = await fetch(`${BUYER_LOGO_PATH}?${params.toString()}`, {
        method: 'POST',
        body: options === null || options === void 0 ? void 0 : options.data,
        headers: Object.assign({}, csrfToken ? {
          'X-Hs-Membership-Csrf': csrfToken
        } : {}),
        credentials: 'include'
      });
      if (!response.ok) {
        throw new Error(`Buyer logo upload failed: ${response.status}`);
      }
      const json = await response.json();
      return {
        objects: [{
          url: json.fileUrl,
          id: 0,
          type: 'IMG',
          full_path: json.fileUrl,
          name: '',
          extension: ''
        }]
      };
    }
  };
}